import React from 'react'

import Title from '@cinch/oxd-components/page-title/src'
import RichText from '@cinch/oxd-components/rich-text/src'
import Layout from '@cinch/oxd-layouts/regular/src'

const Page: React.FC<{ title: string; content: string }> = ({ title, content }) => {
  return (
    <Layout>
      <Title>{title}</Title>
      <RichText>{content}</RichText>
    </Layout>
  )
}

export default Page
